import { Box } from '@material-ui/core';
import 'App.scss';
import ChatContainer from 'components/chatWidget/chat/ChatContainer';
import React from 'react';
// import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Layout from 'view/layout/Layout';
const App = (props) => {
  return (
    <Box className="app-container">
      <Layout />
      <ChatContainer caId={9999} />
    </Box>
  );
};

export default connect(
  (state) => ({
    // account: state.system.account,
  }),
  {}
)(withRouter(App));
